import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { keyBy } from 'lodash/fp';
import { useSelector } from 'app/lib/hooks';
import { selectEnvironments } from 'app/store/jobs';
import { useFormContext } from 'app/components/core/Form';
import { Hint } from 'app/components/core/Hint';
import { JobEnvironmentField } from 'app/components/features/JobDialog';
import { DialogChapter, KeyValueSummary } from 'app/components/features/DialogWithChapters';

export function ProjectEnvironmentChapter({ isOptional = false, hint }) {
    const { t } = useTranslation();

    const { getFieldValue } = useFormContext();

    const environmentUid = getFieldValue('environmentUid');
    const environments = useSelector(selectEnvironments);
    const environmentsById = useMemo(() => keyBy('uid', environments), [environments]);

    const summary = useMemo(() => {
        const values = {
            [t('common:name')]: environmentsById[environmentUid]?.name
        };
        return <KeyValueSummary values={values} />;
    }, [t, environmentsById, environmentUid]);

    return (
        <DialogChapter
            label={t('components:CreateProjectEnv.projectEnv')}
            summary={summary}
            isOptional={isOptional}>
            {hint && <Hint>{hint}</Hint>}
            <JobEnvironmentField />
        </DialogChapter>
    );
}
